import jsPDF from 'jspdf';
import moment from 'moment';

export function getHotelUpdateDifference(obj1, obj2) {
    return Object.keys(obj2).reduce((cur, next) => {
        if (String(next).toUpperCase() === 'MANAGER') {
            const removed = obj1[next].filter((item) => !obj2[next].includes(item));
            const added = obj2[next].filter((item) => !obj1[next].includes(item));
            cur.manager = {
                removed,
                added
            };
        } else {
            if (obj1[next] !== obj2[next]) {
                cur[next] = obj2[next];
            }
        }
        return cur;
    }, {});
}

export function convertToTitleCase(str) {
    const words = str.split('_');
    const capitalizedWords = words.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());
    return capitalizedWords.join(' ');
}

export function camelToTitle(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^./, (match) => match.toUpperCase());
}

export function calculateTax(price) {
    return (price * (2.5 / 100)).toFixed(2);
}

export function calculatePlatformFees(price) {
    // switch (true) {
    //     case price <= 0:
    //         return 0;
    //     case price < 100:
    //         return Number((price / 100).toFixed(2));
    //     case price <= 200:
    //         return 0.99;
    //     case price <= 1000:
    //         return 1.99;
    //     default:
    //         return 2.99;
    // }
    return 0;
    // if (price <= 0) return 0;
    // return 2 + (2 * 0.18);
}

export const isNumber = (value) => {
    return !isNaN(parseFloat(value)) && isFinite(value);
};

export function formatNumber(num, fixed = 2) {
    let result;
    num = Number(num);
    switch (true) {
        case (num < 1000):
            result = num.toFixed(fixed);
            break;

        case (num < 100000):
            result = (num / 1000).toFixed(fixed) + 'k';
            break;

        case (num < 10000000):
            result = (num / 100000).toFixed(fixed) + 'L';
            break;

        default:
            result = (num / 10000000).toFixed(fixed) + 'Cr';
            break;
    }
    return result;
}

export function formatIndianNumber(num, decimal, fixed = 2) {
    return decimal
        ? Number(num).toLocaleString('en-IN', {
            minimumFractionDigits: fixed,
            maximumFractionDigits: fixed
        })
        : num.toLocaleString('en-IN');
}

export function printBill(data) {
    // 58mm = ~227pt, height dynamic (base + per item)
    const lineHeight = 20;
    const baseHeight = 200;
    const pageHeight = baseHeight + data.items.length * lineHeight + 100;
    const pageWidth = 227;

    // eslint-disable-next-line new-cap
    const doc = new jsPDF({
        unit: 'pt',
        format: [pageWidth, pageHeight] // custom thermal size
    });

    const centerText = (text, y, fontSize = 10) => {
        doc.setFontSize(fontSize);
        const textWidth = doc.getTextWidth(text);
        const x = (pageWidth - textWidth) / 2;
        doc.text(text, x, y);
    };

    const wrapText = (text, maxWidth) => {
        return doc.splitTextToSize(text, maxWidth);
    };

    let y = 20;
    doc.setFont('courier', 'normal');

    // --- HEADER ---
    centerText(data.hotelName || '', y, 12);
    y += 16;

    wrapText(data.hotelAddress || '', pageWidth - 20).forEach(line => {
        centerText(line, y);
        y += 12;
    });

    if (data.phone) {
        centerText(`Ph: ${data.phone}`, y);
        y += 14;
    }

    doc.text('-'.repeat(35), 10, y);
    y += 16;

    // --- BILL INFO ---
    doc.setFontSize(10);
    doc.text(`Bill No: ${data.billNo}`, 10, y);
    y += 14;
    doc.text(`Date: ${moment().format('DD-MM-YYYY, hh:mm A')}`, 10, y);
    y += 16;

    doc.text('-'.repeat(35), 10, y);
    y += 16;

    // --- TABLE HEADER ---
    doc.text('Item'.padEnd(17) + 'Qty'.padEnd(5) + 'Price'.padEnd(8) + 'Amt', 10, y);
    y += 14;
    doc.text('-'.repeat(35), 10, y);
    y += 16;

    // --- ITEMS ---
    let totalQty = 0;
    let grandTotal = 0;

    data.items.forEach(it => {
        const amount = it.qty * it.price;
        totalQty += it.qty;
        grandTotal += amount;

        // Wrap item name
        const nameLines = wrapText(it.name, 100);

        // First line includes qty/price/amt
        doc.text(
            nameLines[0].padEnd(18) +
            String(it.qty).padEnd(3) + ' ' +
            String(Number(it.price).toFixed(2)).padEnd(3) + ' ' +
            String(Number(amount).toFixed(2)),
            10,
            y
        );
        y += 14;

        // Remaining lines (only item name)
        for (let i = 1; i < nameLines.length; i++) {
            doc.text(nameLines[i], 10, y);
            y += 14;
        }
    });

    doc.text('-'.repeat(35), 10, y);
    y += 14;

    // --- FOOTER TOTALS ---
    doc.text(`Items: ${data.items.length}`, 10, y);
    doc.text(`Total Q: ${totalQty}`, 150, y);
    y += 14;

    doc.text('-'.repeat(35), 10, y);
    y += 14;

    const gtStr = grandTotal.toFixed(2);
    doc.text('Grand Total:', 10, y);
    doc.text(gtStr, pageWidth - doc.getTextWidth(gtStr) - 10, y);
    y += 20;

    doc.text('-'.repeat(35), 10, y);
    y += 20;

    centerText('Thank you! Visit Again!', y);
    y += 40;

    doc.save('bill.pdf'); // you can use doc.save("bill.pdf") or doc.output()
}

export function formatQuantityUnit(quantity, unit) {
    if (['g', 'ml'].includes(unit) && quantity > 1000) {
        const qty = quantity / 1000;
        return {
            quantity: Math.floor(qty * 100) / 100,
            unit: unit === 'g' ? 'kg' : 'l'
        };
    }
    return { quantity, unit };
}

export const normalize = (str) =>
    (str || '')
        .toLowerCase()
        .trim()
        .replace(/\s+/g, ' ')
        .replace(/[^\w\s]/gi, '');
